/**
 * Joins an array of optional string parts into a single string,
 * filtering out null, undefined, and empty values.
 *
 * Useful for building human-readable address or metadata strings
 * from partially-populated data.
 */
export function joinParts(
  parts: (string | null | undefined)[],
  separator = ', '
): string {
  return parts.filter(Boolean).join(separator);
}
